// packages/web/src/api/lodging-declarations/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { lodgingDeclarationsList, lodgingDeclarationsGet } from "../generated/sdk.gen.ts";
import { lodgingKeys } from "./keys.ts";

export function lodgingInboxOptions(userId: string) {
  return queryOptions({
    queryKey: lodgingKeys.inbox(userId),
    queryFn: async () => {
      const { data, error } = await lodgingDeclarationsList({ query: { inbox: "me" } });
      if (error) throw error;
      if (!data) throw new Error("Lodging inbox failed");
      return data.data;
    },
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}

export function lodgingDetailOptions(id: string) {
  return queryOptions({
    queryKey: lodgingKeys.detail(id),
    queryFn: async () => {
      const { data, error } = await lodgingDeclarationsGet({ path: { id } });
      if (error) throw error;
      if (!data) throw new Error("Lodging get failed");
      return data;
    },
    staleTime: 30_000,
  });
}
